<template>
    <svg id="_2911838904496" xmlns="http://www.w3.org/2000/svg" width="30" height="19.012" viewBox="0 0 30 19.012">
        <path id="Caminho_60" data-name="Caminho 60"
            d="M609.57,1450.512H582.589c-.833,0-1.509-.482-1.509-1.076s.676-1.076,1.509-1.076H609.57c.833,0,1.51.482,1.51,1.076S610.4,1450.512,609.57,1450.512Z"
            transform="translate(-581.08 -1448.36)" fill="#f58634" />
        <path id="Caminho_61" data-name="Caminho 61"
            d="M609.57,1543.943H582.589c-.833,0-1.509-.482-1.509-1.076s.676-1.076,1.509-1.076H609.57c.833,0,1.51.482,1.51,1.076S610.4,1543.943,609.57,1543.943Z"
            transform="translate(-581.08 -1533.36)" fill="#f58634" />
        <path id="Caminho_62" data-name="Caminho 62"
            d="M609.57,1637.372H582.589c-.833,0-1.509-.482-1.509-1.076s.676-1.076,1.509-1.076H609.57c.833,0,1.51.482,1.51,1.076S610.4,1637.372,609.57,1637.372Z"
            transform="translate(-581.08 -1618.36)" fill="#f58634" />
    </svg>
</template>